import mock from '../mock'
import { paginateArray } from '../utils'

const data = {
    ipList: [
        {
            id: 1,
            fullName: 'Test Data',
            company: 'Yotz PVT LTD',
            role: 'editor',
            username: 'gslixby0',
            country: 'El Salvador',
            contact: '(479) 232-9151',
            email: 'gslixby0@abc.net.au',
            currentPlan: 'enterprise',
            status: 'pasif',
            lastActive: '13.04.2020',
            avatar: ''
        },
        {
            id: 2,
            fullName: 'Halsey Redmore',
            company: 'Skinder PVT LTD',
            role: 'author',
            username: 'hredmore1',
            country: 'Albania',
            contact: '(472) 607-9137',
            email: 'hredmore1@imgur.com',
            currentPlan: 'team',
            status: 'aktif',
            lastActive: '13.04.2020',
            avatar: ''
        },
        {
            id: 3,
            fullName: 'Marjory Sicely',
            company: 'Oozz PVT LTD',
            role: 'maintainer',
            username: 'msicely2',
            country: 'Russia',
            contact: '(321) 264-4599',
            email: 'msicely2@who.int',
            currentPlan: 'enterprise',
            status: 'aktif',
            lastActive: '13.04.2020',
            avatar: ''
        },
        {
            id: 4,
            fullName: 'Cyrill Risby',
            company: 'Oozz PVT LTD',
            role: 'maintainer',
            username: 'crisby3',
            country: 'China',
            contact: '(923) 690-6806',
            email: 'crisby3@wordpress.com',
            currentPlan: 'team',
            status: 'pasif',
            lastActive: '13.04.2020',
            avatar: ''
        },
        {
            id: 5,
            fullName: 'Maggy Hurran',
            company: 'Aimbo PVT LTD',
            role: 'subscriber',
            username: 'mhurran4',
            country: 'Pakistan',
            contact: '(669) 914-1078',
            email: 'mhurran4@yahoo.co.jp',
            currentPlan: 'enterprise',
            status: 'aktif',
            lastActive: '13.04.2020',
            avatar: ''
        },
        {
            id: 6,
            fullName: 'Silvain Halstead',
            company: 'Jaxbean PVT LTD',
            role: 'author',
            username: 'shalstead5',
            country: 'China',
            contact: '(958) 973-3093',
            email: 'shalstead5@shinystat.com',
            currentPlan: 'company',
            status: 'pasif',
            lastActive: '13.04.2020',
            avatar: ''
        }
    ]
}

// GET ALL DATA
mock.onGet('/api/ipList/list/all-data').reply(200, data.ipList)

// // POST: Add new IP
// mock.onPost('/apps/ipList/add-user').reply(config => {
//     // Get event from post data
//     const ip = JSON.parse(config.data)

//     const { length } = data.ipList
//     let lastIndex = 0
//     if (length) {
//         lastIndex = data.ipList[length - 1].id
//     }
//     ip.id = lastIndex + 1

//     data.ipList.unshift(ip)

//     return [201, { ip }]
// })

// GET Updated IP
mock.onGet('/api/ipList/list/data').reply(config => {
    const { q = '', perPage = 10, page = 1, role = null, currentPlan = null, status = null } = config

    /* eslint-disable  */
    const queryLowered = q.toLowerCase()
    const filteredData = data.ipList.filter(
        ip =>
            (ip.username.toLowerCase().includes(queryLowered) || ip.fullName.toLowerCase().includes(queryLowered)) &&
            ip.role === (role || ip.role) &&
            ip.currentPlan === (currentPlan || ip.currentPlan) &&
            ip.status === (status || ip.status)
    )
    /* eslint-enable  */

    return [
        200,
        {
            ipList: paginateArray(filteredData, perPage, page),
            total: filteredData.length
        }
    ]
})

// GET IP
mock.onGet('/api/ipList/ip').reply(config => {
    const { id } = config
    const ip = data.ipList.find(i => i.id === id)
    return [200, { ip }]
})

// DELETE: Deletes IP
mock.onDelete('/apps/ipList/delete').reply(config => {
    // Get ip id from URL
    let ipID = config.id

    // Convert Id to number
    ipID = Number(ipID)

    const userIndex = data.ipList.findIndex(t => t.id === ipID)
    data.ipList.splice(userIndex, 1)

    return [200]
})
